<template>
  <div class="container-background text-center">

    <h5>شــنبه تا پنج شــنبه</h5>
    <div class="my-3">
      <a v-for="instagram in findAttributeOnSiteInfo('social_media_instagram')"
         :key="instagram"
         :href="`${instagram}`">
        <img :src="image" :alt="alt" class="instagram-width">
      </a>
    </div>

    <div class="my-3">

      <a class="  text-dark text-decoration-none"
         v-for="(tel_phone ,index) in findAttributeOnSiteInfo('tel_phone')" :key="index"
         :href="`tel:${tel_phone}`">
        <h4 class="">{{ tel_phone }}</h4>
      </a>

      <a class="  text-dark text-decoration-none"
         v-for="(cell_phone ,index) in findAttributeOnSiteInfo('cell_phone')" :key="index"
         :href="`tel:${cell_phone}`">
        <h4 class="">{{ cell_phone }}</h4>
      </a>

    </div>

    <h5 v-for="(address ,index) in findAttributeOnSiteInfo('address')" :key="index">{{ address }}</h5>

  </div>
</template>

<script>

export default {
  name: "ContactUs",
  props: {
    image: {
      default: 'https://api.cafen2.ir/storage/assets/instagram.d8a39059.png'
    },
    alt: {
      default: 'cafe n2'
    },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  async mounted() {
  }
};
</script>

<style>
.custom-footer {
  margin: -120px 0 0 0;
}

.custom-footer .footer-icon-1 {
  background: var(--secondary) !important;
}
</style>

<style scoped>
.instagram-width {
  width: 250px
}
</style>